import { useMediaQuery } from '@vueuse/core';

/**
 * Detects devices with no hover capability and a coarse (touch) pointer,
 * e.g. phones/tablets used as a PWA. Used to adjust UX that assumes a mouse
 * (hover-revealed menus, autofocus on the reply editor) without touching
 * desktop behavior.
 */
export function useIsTouchDevice() {
  const isTouchDevice = useMediaQuery('(hover: none) and (pointer: coarse)');
  return { isTouchDevice };
}
